
import { Placement } from '@post-office/placements-frontend/jira-issue-view-comment-top-banner';
export default Placement;
